module.exports = __webpack_public_path__ + "img/tclogo2.024d8df2.png";